import React, { useEffect, useContext } from 'react';

import Loader from '~/containers/QuoteEstimates/Loader';
import { PG_ERROR_URL } from '~/components/ErrorBoundary';

import { AuthContext } from '../';
import { ANON_TOKEN_TYPE, AUTH_ERROR, UPDATE_TOKEN } from '../constants';

import { useGetUserData } from './hooks/useGetUserData';
import useTokenTimeout from './hooks/useTokenTimeout';
import getTokenFromAnonServer from './getTokenFromAnonServer';

interface AuthSessionProps {
  children: React.ReactNode;
}

const CypressAuthSession = ({ children }: AuthSessionProps) => {
  const {
    authDispatch,
    auth: { loading, error },
  } = useContext(AuthContext);

  useTokenTimeout();
  useGetUserData();

  useEffect(() => {
    const getAuthToken = async () => {
      try {
        const anonRes = await getTokenFromAnonServer();

        if (anonRes.status === 'SUCCESS') {
          const { value } = anonRes;

          authDispatch({
            type: UPDATE_TOKEN,
            payload: { token: value.token, tokenType: ANON_TOKEN_TYPE },
          });

          return value.token;
        }
        authDispatch({ type: AUTH_ERROR, payload: { error: anonRes.value.message } });
      } catch (err) {
        authDispatch({ type: AUTH_ERROR, payload: { error: err.message } });
      }
    };

    getAuthToken();
  }, [authDispatch]);

  useEffect(() => {
    if (error) {
      window.location.assign(PG_ERROR_URL);
    }
  }, [error]);

  if (loading || error) {
    return <Loader />;
  }

  return <div data-testid="cypress-auth-session"> {children} </div>;
};

export default CypressAuthSession;
